import { render } from "./ClaimReward.vue?vue&type=template&id=2e9e50a2&scoped=true"
import script from "./ClaimReward.vue?vue&type=script&lang=js"
export * from "./ClaimReward.vue?vue&type=script&lang=js"

import "./ClaimReward.vue?vue&type=style&index=0&id=2e9e50a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9e50a2"]])

export default __exports__